import { tv } from 'tailwind-variants';

export const buttonColors = ['primary', 'secondary', 'accent', 'warning'];
export const buttonVariants = ['solid', 'outline'];
export const buttonSizes = ['xs', 'sm', 'md', 'lg', 'xl'];

export default tv({
    slots: {
        base: 'focus-visible:outline-accent relative inline-flex shrink-0 cursor-pointer items-center justify-center rounded-md text-center font-medium transition-colors ease-in-out focus-visible:outline-2 disabled:cursor-not-allowed aria-disabled:cursor-not-allowed',
        label: 'truncate',
        leadingIcon: 'shrink-0',
        trailingIcon: 'shrink-0',
        loadingIndicator: 'absolute inset-0 flex items-center justify-center opacity-0',
        loadingIcon: 'shrink-0 animate-spin',
    },
    variants: {
        color: {
            primary: '',
            secondary: '',
            accent: '',
            warning: '',
        },
        variant: {
            solid: 'focus-visible:outline-offset-2',
            outline: '',
        },
        size: {
            xs: {
                base: 'px-2 py-1.5 text-xs leading-[1.2] -tracking-[0.12px]',
                leadingIcon: '-ms-0.5 me-1 size-3',
                trailingIcon: 'ms-1 -me-0.5 size-3',
                loadingIcon: 'size-3',
            },
            sm: {
                base: 'px-3 py-2 text-xs leading-[1.2] -tracking-[0.12px]',
                leadingIcon: '-ms-1 me-1.5 size-3',
                trailingIcon: 'ms-1.5 -me-1 size-3',
                loadingIcon: 'size-3',
            },
            md: {
                base: 'px-4 py-2 text-sm -tracking-[0.14px]',
                leadingIcon: '-ms-1.5 me-2 size-5',
                trailingIcon: 'ms-2 -me-1.5 size-5',
                loadingIcon: 'size-5',
            },
            lg: {
                base: 'h-[52px] px-4.5 py-4 text-base leading-4.5 -tracking-[0.16px]',
                leadingIcon: '-ms-1 me-2 size-5',
                trailingIcon: 'ms-2 -me-1 size-5',
                loadingIcon: '-my-1 size-5',
            },
            xl: {
                base: 'h-[70px] justify-between rounded-[10px] px-[25px] text-[32px] leading-tight',
                leadingIcon: '-ms-1.5 me-7 size-8',
                trailingIcon: 'ms-7 -me-1.5 size-8',
                loadingIcon: 'size-8',
            },
        },
        block: {
            true: {
                base: 'w-full justify-between',
                label: 'text-center',
                leadingIcon: '',
                trailingIcon: '',
            },
        },
        loading: {
            true: {
                base: 'pointer-events-none *:data-loading-indicator:opacity-100 [&>:not([data-loading-indicator])]:opacity-0',
            },
        },
        disabled: {
            true: 'opacity-25',
        },
        trailing: {
            true: '',
        },
        icon: {
            true: '',
        },
    },
    compoundVariants: [
        {
            color: 'primary',
            variant: 'solid',
            class: 'border-primary bg-primary hover:text-primary focus-visible:outline-accent disabled:bg-primary border text-white hover:bg-transparent disabled:text-white',
        },
        {
            color: 'secondary',
            variant: 'solid',
            class: 'text-primary hover:bg-primary disabled:text-primary border border-white bg-white hover:text-white disabled:bg-white',
        },
        {
            color: 'primary',
            variant: 'outline',
            class: 'border-primary text-primary hover:bg-primary border bg-transparent hover:text-white',
        },
        {
            color: 'secondary',
            variant: 'outline',
            class: 'hover:text-primary border border-white bg-transparent text-white hover:bg-white',
        },
        {
            color: 'primary',
            variant: 'outline',
            size: 'xl',
            class: 'border-2',
        },
        {
            color: 'secondary',
            variant: 'outline',
            size: 'xl',
            class: 'border-2',
        },
        {
            color: 'accent',
            variant: 'solid',
            class: 'border-accent bg-accent disabled:bg-accent hover:text-accent border text-white hover:bg-transparent disabled:text-white',
        },
        {
            color: 'accent',
            variant: 'outline',
            class: 'border border-[#172CB6] bg-transparent text-[#172CB6] hover:bg-[#172CB6] hover:text-[#D9E6FF]',
        },
        {
            color: 'warning',
            variant: 'solid',
            class: 'border border-[#82280C] bg-[#82280C] text-white hover:bg-transparent hover:text-[#82280C] focus-visible:outline-[#82280C]',
        },
        {
            color: 'warning',
            variant: 'outline',
            class: 'border border-[#82280C] bg-transparent text-[#82280C] hover:bg-[#82280C] hover:text-[#FFECD3] focus-visible:outline-[#82280C]',
        },
    ],
    defaultVariants: {
        color: 'primary',
        variant: 'solid',
        size: 'md',
    },
});
